import { handleActions, combineActions } from 'redux-actions'
import types from './types'

const INITIAL_STATE = {
  isLoading: false,
  noticeForms: [],
  pageCount: 0,
  resultsCount: 0,
}

const beginLoading = combineActions(types.SEARCH_NOTICE_FORMS)

const stopLoading = combineActions(
  types.SEARCH_NOTICE_FORMS_SUCCESS,
  types.SEARCH_NOTICE_FORMS_FAIL
)

const reducer = handleActions(
  {
    [beginLoading]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [stopLoading]: (state) => ({
      ...state,
      isLoading: false,
    }),
    [types.SEARCH_NOTICE_FORMS_SUCCESS]: (
      state,
      {
        payload: {
          data: { data },
        },
      }
    ) => ({
      ...state,
      noticeForms: data.notices,
      pageCount: data.pageCount,
      resultsCount: data.resultsCount,
      isLoading: false,
    }),
    [types.CLEAR_STATE]: () => {
      return { ...INITIAL_STATE }
    },
  },
  INITIAL_STATE
)

export default reducer
